import Box from '@mui/material/Box';
import { Formik} from '../../lib/formik/Formik';
import * as yup from 'yup';
import { MFTextField, MFSubmitButton } from '../../lib/formik';
import { useDispatch } from 'react-redux';
import { loginWithOtp } from '../../redux-store/actions/auth';
import { useHistory, useRouteMatch } from 'react-router';
import { numberRegex, phoneRegExp } from '../../utils/regex';
import {
  GetDetailsFromPaymentIdRes,
  GetDetailsFromRefIDResponse,
  GetOtpForInvestorResponse,
  LoginWithOtpResponseBody,
} from '../../redux-store/types/api-types';
import { CountryCodesDropDown, LoginLayout } from '../commonComponents';
import { getCountryCodes, preventSpecialCharacters } from '../../utils/utilityFunctions';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { useEffect, useState } from 'react';
import { getDetailsWithReferenceId, getOtpForInvestor, getDetailsWithPaymentId, getOtpForPaymentFlow } from '../../redux-store/actions/onBoarding';
import {
  Button,
  Theme,
  Typography
} from '@mui/material';
import { VERIFY_LOGIN_OTP_SUCCESS } from '../../redux-store/types/auth';
import { ENABLE_DIY_INVESTOR_ONBOARDING } from '../../utils/constant';

interface Values {
  mobile: string;
  countryCode: string;
  countryNameAndCode: string;
}

const validationSchema = yup.object().shape({
  // mobile: yup
  //   .string()
  //   .required('Mobile number is required')
  //   .matches(phoneRegExp, 'Mobile number is not valid')
  //   .length(10, 'Mobile number should be maximum 10 digits'),
  mobile: yup.string().test('mobile', (value, context) => {
    const { createError, path, parent } = context;

    const selectedCodeObj = (getCountryCodes() ?? []).find((codes) => {
      if (codes.label === parent.countryNameAndCode) {
        return codes;
      }
    })

    if (!value) {
      return createError({
        message: 'Mobile number is required',
        path,
      });
    }
    if (!numberRegex.test(`${value ?? ""}`)) {
      return createError({
        message: 'Invalid Mobile number',
        path,
      });
    }

    if (
      `${selectedCodeObj?.countryCode ?? ""}`.toLowerCase() === "in" &&
      `${value ?? ""}`.length !== 10
    ) {
      return createError({
        message: 'Please enter a valid 10 digit mobile number',
        path,
      });
    }
    // if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
    //   return createError({
    //     message: 'Invalid Mobile number',
    //     path,
    //   });
    // }
    // if (!isValidPhoneNumber(value, `${selectedCodeObj?.countryCode ?? ""}` as CountryCode)) {
    //   return createError({
    //     message: 'Invalid Mobile number',
    //     path,
    //   });
    // }
    return true;
  }),
  countryNameAndCode: yup
    .string()
    .nullable()
    .test('countryNameAndCode', (value, context) => {
      const { createError, path, parent } = context;
      const codesList = getCountryCodes()
        .map((codes) => {
          if (codes.label === value) {
            return codes.countryCode;
          }
        })
        .filter((ele) => ele)
        .toString();
      if (!value) {
        return createError({
          message: 'Country Code is required',
          path,
        });
      }
      // if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
      //   return createError({
      //     message: 'Invalid Mobile number',
      //     path,
      //   });
      // }

      return true;
    }),
});

export default function MobileLogin(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();

  const [isLoading, setLoading] = useState<boolean>(false)
  const { params } = useRouteMatch();
  const { referenceId, paymentId } = params as unknown as { referenceId: string, paymentId: string };

  const verifyUser = async () => {
    try {
      setLoading(true)

      const response = (await dispatch(
        getOtpForInvestor(referenceId)
      )) as unknown as GetOtpForInvestorResponse;
      if (response?.verificationToken) {
        history.push('verify-pan', {
          ...(response || {}),
          phone: (response || {}).phone,
          email: (response || {}).email,
          loginType: 'investor',
          referenceId,
        })
      }
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false)
    }
  };

  const verifyOtpForPayment = async () => {
    try {
      setLoading(true);
      const response = (await dispatch(
        getOtpForPaymentFlow(paymentId)
      )) as unknown as GetOtpForInvestorResponse;
      history.push('payment-verify-pan', {
        ...(response || {}),
        phone: (response || {}).phone,
        email: (response || {}).email,
        loginType: 'payment',
        paymentId,
      });
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false)
    }
  }
  const onSubmit = async (values: Values) => {
    try {
      setLoading(true)
      const { mobile = '', countryCode = '+91', countryNameAndCode = 'India: +91' } = values;
      const res = (await dispatch(
        loginWithOtp({
          phone: mobile.trim(),
          countryCode: countryNameAndCode?.split(':')[1].trim(),
        })
      )) as unknown as LoginWithOtpResponseBody;

      // If isEmailVerificationRequired = true, route to Email and Role screen to enter email and role
      if (res?.isEmailVerificationRequired) {
        history.push('select-role', {
          ...(res || {})
        })

        return
      }

      // If isEmailVerificationRequired = false, route to Verify OTP screen for OTP verification
      if (res?.verificationToken) {
        history.push('verify-otp', {
          ...(res || {}),
        });

        return
      }
    } catch (e) {
      console.error((e as unknown as Error).message);
    } finally {
      setLoading(false)
    }
  };


  const [initialValues, setInitialValues] = useState<Values>({
    mobile: '',
    countryCode: '+91',
    countryNameAndCode: 'India: +91',
  });

  const Api = async () => {
    try {
      setLoading(true)
      const response = (await dispatch(
        getDetailsWithReferenceId(referenceId)
      )) as unknown as GetDetailsFromRefIDResponse;
      referenceId &&
        setInitialValues({
          mobile: response?.phone,
          countryCode: response?.countryCode,
          countryNameAndCode: response?.countryNameAndCode,
        });
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false)
    }
  };
  const PaymentApi = async () => {
    try {
      setLoading(true)
      const response = (await dispatch(
        getDetailsWithPaymentId(paymentId)
      )) as unknown as GetDetailsFromPaymentIdRes;
      paymentId &&
        setInitialValues({
          mobile: response?.phone,
          countryCode: response?.countryCode,
          countryNameAndCode: response?.countryNameAndCode,
        });
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false)
    }
  };
  useEffect(() => {
    referenceId && Api();
  }, [referenceId]);

  useEffect(() => {
    paymentId && PaymentApi();
  }, [paymentId])

  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  
  useEffect(() => {
    const mobileElement = document.getElementsByName('mobile');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);

    if (!referenceId && !paymentId) {
      mobileElement[0]?.focus();
    }
  }, []);

  const handleCreateAccount = () => {
    dispatch({
      type: VERIFY_LOGIN_OTP_SUCCESS,
      body: {
        diyInvestorOnboarding: true
      }
    })
    history.replace('/investor-onboarding');
  }

  return (
    <LoginLayout LoginText="Login">
      <>
        <Formik
          onSubmit={paymentId ? verifyOtpForPayment : referenceId ? verifyUser : onSubmit}
          initialValues={initialValues}
          enableReinitialize={true}
          validationSchema={validationSchema}>
          {({ handleSubmit, values }) => {
            return (
              <Box
                component="form"
                noValidate
                autoComplete='off'
                onSubmit={handleSubmit}
                sx={{
                  '.MuiLoadingButton-root': {
                    mt: 3,
                  },
                  // '.MuiInputLabel-root': {
                  //   fontFamily: 'Poppins, sans-serif',
                  //   fontSize: 16,
                  //   fontWeight: 500,
                  // },
                }}>
                <MFTextField
                  label="Mobile Number *"
                  // type='number'
                  name="mobile"
                  placeholder="Enter Mobile number"
                  autoComplete="tel"
                  readOnly={isLoading}
                  onKeyDown={(e) => {
                    preventSpecialCharacters(e);
                  }}
                  startAdornment={
                    <CountryCodesDropDown
                      ElementWidth={mobileElementWidth && mobileElementWidth}
                      name={'countryNameAndCode'}
                      value={values.countryNameAndCode}
                      disabled={(referenceId || paymentId) ? true : false}
                    />
                  }
                  // sx={{
                  //   backgroundColor: referenceId && 'gray',
                  // }}
                  // autoFocus={!referenceId ? true : false}
                  disabled={(referenceId || paymentId) ? true : false}
                />
                {/* <MFTextField
              required
              label="Enter Mobile Number"
              name="mobile"
              type="text"
              placeholder="Enter Mobile Number"
              autoComplete="off"
              autoFocus
            /> */}
                <MFSubmitButton
                  label="Get OTP"
                  loadingEnable={isLoading}
                />
              </Box>
            );
          }}
        </Formik>
        {
          ENABLE_DIY_INVESTOR_ONBOARDING && (
            <Box
              sx={(theme: Theme) => ({
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                columnGap: "15px",
                marginTop: "20px",
                color: theme.palette.text.secondary
              })}
            >
              <Typography
                variant='subtitle_500'
                sx={{ fontWeight: 500, lineHeight: 1.2 }}
              >
                Are you a new investor and would like to self onboard?
              </Typography>
              <Button
                sx={(theme: Theme) => ({
                  ...theme.typography.subtitle_500,
                  color: theme.palette.primary[500],
                  padding: "10px",
                  fontWeight: 500,
                  lineHeight: 1.2,
                })}
                onClick={handleCreateAccount}
                disabled={isLoading}
              >
                Create account
              </Button>
            </Box>
          )}
      </>
    </LoginLayout >
  );
}
